// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app-name[data-v-8de9dc66]{display:inline-block;font-family:\"Amaranth\",\"San Francisco UI\",\"Helvetica Neue\",Helvetica,Arial,sans-serif;font-size:20px;text-transform:capitalize}.logout[data-v-8de9dc66]{float:right!important}.logout i[data-v-8de9dc66]{margin-top:-4px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
